import {
  GroupReqType,
  LoginReqType,
  SignUpReqType,
} from "../types/api/userApiType";
import { checkErrorType } from "../utils/apiUtils";
import axiosInstance from "./axiosInstance";

export const requestLogin = async (loginInfo: LoginReqType) => {
  try {
    const response = await axiosInstance.post("/user/login", loginInfo);
    return { ...response.data, isSuccess: true };
  } catch (e: any) {
    checkErrorType(e.config.url, e.response?.status);
    return { isSuccess: false };
  }
};

export const createUser = async (signUpInfo: SignUpReqType) => {
  try {
    const response = await axiosInstance.post("/user/join", signUpInfo);
    return { ...response.data, isSuccess: true };
  } catch (e: any) {
    checkErrorType(e.config.url, e.response?.status);
    return { isSuccess: false };
  }
};

export const getGroupList = async () => {
  try {
    const response = await axiosInstance.get("/groups");
    return { ...response.data, isSuccess: true };
  } catch (e: any) {
    checkErrorType(e.config.url, e.response?.status);
    return { isSuccess: false };
  }
};

export const createGroup = async (groupInfo: GroupReqType) => {
  try {
    const response = await axiosInstance.post("/groups", groupInfo);
    return { ...response.data, isSuccess: true };
  } catch (e: any) {
    checkErrorType(e.config.url, e.response?.status);
    return { isSuccess: false };
  }
};

export const getMyInfo = async () => {
  try {
    const response = await axiosInstance.get("/user/detail-me");

    return { ...response.data, isSuccess: true };
  } catch (e: any) {
    checkErrorType(e.config.url, e.response?.status);
    return { isSuccess: false };
  }
};
